import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';

export const getPlatforms =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.platformTransferFees.getPlatforms();
      onSuccess && onSuccess(data['providersResponse']);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const updatePlatform =
  ({ platformData, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.platformTransferFees.updatePlatform({
        payload: {
          providers_request: [{ ...platformData }]
        }
      });
      onSuccess && onSuccess(data['providersResponse'][0]);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
